import Header from './components/Header';
import HeroSection from './components/HeroSection';
import RankingSection from './components/RankingSection';
import MediaSection from './components/MediaSection';
import CommentsSection from './components/CommentsSection';
import FeaturesSection from './components/FeaturesSection';
import UpdatesSection from './components/UpdatesSection';
import CarouselSection from './components/CarouselSection';
import CardsSection from './components/CardsSection';
import IndexSection from './components/IndexSection';
import ContactSection from './components/ContactSection';
import FaqSection from './components/FaqSection';
import TopicsSection from './components/TopicsSection';
import AboutSection from './components/AboutSection';
import AppSection from './components/AppSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <>
      <Header />
      <main>
        <HeroSection />
        <RankingSection />
        <MediaSection />
        <CommentsSection />
        <FeaturesSection />
        <UpdatesSection />
        <CarouselSection />
        <CardsSection />
        <IndexSection />
        <ContactSection />
        <FaqSection />
        <TopicsSection />
        <AboutSection />
        <AppSection />
      </main>
      <Footer />
    </>
  );
}